import React from 'react';
import { Instance } from '../types';
import '../styles/CTXRegisterStyles.css';

interface InstanceSelectorProps {
    instances: Instance[];
    selectedInstance: string;
    handleInstanceChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const InstanceSelector: React.FC<InstanceSelectorProps> = ({ instances, selectedInstance, handleInstanceChange }) => (
    <div className="d-flex flex-column flex-row-auto syslog-header">
        <label htmlFor="instanceSelect" className="form-label f-bold fs-p text-marino required form-label">CTX-R</label>
        <div className="select-container">
            <select
                id="instanceSelect"
                value={selectedInstance}
                onChange={handleInstanceChange}
                className="custom-select"
                aria-label="Select example"
            >
                {instances.length === 0 ? (
                    <option disabled>No data</option>
                ) : (
                    <>
                        <option disabled selected hidden>Select a CTX-R</option>
                        {instances.map((instance) => (
                            instance && instance.id && instance.name && instance.description ? (
                                <option key={instance.id} value={instance.name}>
                                    {instance.name} ({instance.description})
                                </option>
                            ) : null
                        ))}
                    </>
                )}
            </select>
        </div>
    </div>
);

export default InstanceSelector;